import 'videojs-airplay';
import 'videojs-airplay/dist/videojs.airplay.css';

export default {};
